var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"loading"},[_vm._v("正在跳转中")]),_c('div',{staticStyle:{"visibility":"hidden"},domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }